import React from 'react'
import MobileHeader from './MobileHeader'
import LargeScreen from './LargeScreen'


const Header = () => {
    return (
        <>
            <MobileHeader />
            <LargeScreen/>
        </>)
}

export default Header